import React from "react";
import styles from "./RatingStars.module.css";

interface RatingStarsProps {
    /** Rating value between 0 and `max`. Fractional values are rendered as
     *  partial-fill stars (e.g. 4.3 fills the 5th star at 30%). */
    value: number;
    max?: number;
    size?: "regular" | "big";
    /** Optional inline label printed next to the stars (e.g. "4.3 / 5"). */
    label?: string;
    ariaLabel?: string;
}

const RatingStars: React.FC<RatingStarsProps> = ({ value, max = 5, size = "regular", label, ariaLabel }) => {
    const clamped = Math.max(0, Math.min(max, value));
    const stars = Array.from({ length: max }, (_, i) => {
        const distanceToValue = clamped - i;
        let fillPct = 0;
        if (distanceToValue >= 1) fillPct = 100;
        else if (distanceToValue > 0) fillPct = Math.round(distanceToValue * 100);
        return fillPct;
    });

    return (
        <span
            className={`${styles.row} ${size === "big" ? styles.big : ""}`.trim()}
            aria-label={ariaLabel || `${clamped} out of ${max} stars`}
            role="img"
        >
            {stars.map((fillPct, idx) => (
                <span key={idx} className={styles.star} style={{ ["--fill" as any]: `${fillPct}%` }} />
            ))}
            {label ? <span className={styles.label}>{label}</span> : null}
        </span>
    );
};

export default RatingStars;
